/**
 * Utility to parse Laravel/Axios errors and extract user-friendly messages.
 */
export const parseError = (error) => {
  // Check if it's a validation error (422)
  if (error.response && error.response.status === 422) {
    const errors = error.response.data.errors;
    if (errors) {
      // Flatten all validation messages into a single array of strings
      const messages = Object.values(errors).flat();
      return messages.join('\n');
    }
    return error.response.data.message || 'Erro de validação.';
  }

  // Handle other known errors
  if (error.response && error.response.data && error.response.data.message) {
    return error.response.data.message;
  }

  // Generic fallback
  return error.message || 'Ocorreu um erro inesperado.';
};
